import { css } from '@emotion/react';
import { CheckIconSmall } from '@frontend/design-system';
import { Text } from '@frontend/design-system';
import * as styles from './styles';

export type StaticVerticalStepperContent = {
  title: string;
  subTitle: string;
};
export interface StaticVerticalStepper {
  stepsInfo: StaticVerticalStepperContent[];
}

export const StaticVerticalStepper = ({ stepsInfo }: StaticVerticalStepper) => {
  return (
    <div css={styles.stepper}>
      <div className='stepper'>
        {stepsInfo.map((step, i) => {
          return (
            <div key={step.subTitle + i} className='step'>
              <div className='line'></div>
              <div
                css={css`
                  display: flex;
                  width: 100%;
                  height: 100%;
                `}
              >
                <div className='step-num'>
                  <CheckIconSmall />
                </div>
                <div className='step-text'>
                  <Text
                    size='large'
                    css={css({
                      whiteSpace: 'pre-wrap',
                    })}
                  >
                    {step.title}
                  </Text>
                  <Text size='small'>{step.subTitle}</Text>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
StaticVerticalStepper.displayName = 'StaticVerticalStepper';
